


function LayoutBottom() {
  return (
    <>
<footer className="footer">
            <div className="row g-0">
                
                <div className="col-4">
                    <div className="lg-footer-logo">
                        <a href="/">
                            <img src="/static/img/footer-logo.png" alt="img" className="img-fluid"/>
                        </a>
                    </div>
                </div>
                <div className="col-8 text-start align-self-end">
                    <ul>
                        <li><a href="https://www.rafedsa.com"><img src="/static/img/website.png" alt="" /></a></li>
                        <li><a href="https://www.youtube.com/c/TatweerTC"><img src="/static/img/YouTube.png" alt=""/></a></li>
                        <li><a href="https://www.instagram.com/rafedsaudi/"><img src="/static/img/Instagram.png" alt=""/></a></li>
                        <li><a href="https://twitter.com/rafedsaudi"><img src="/static/img/Twitter.png" alt=""/></a></li>


                    </ul>
                </div>
            </div>
        </footer>

    </>
  );
}

export default LayoutBottom;
